<article
  class="flex min-h-[220px] flex-col rounded-2xl border border-[#e5e7eb] bg-[#f2f4f7] p-5 transition dark:border-surface-3 dark:bg-surface-1"
  [ngClass]="{
    'cursor-pointer hover:border-[#0c66e8]/25 hover:shadow-[0_4px_16px_rgba(12,102,232,0.08)] dark:hover:border-[#0c66e8]/40': !isDisabled,
    'cursor-not-allowed': unauthorized,
    'cursor-wait': loading,
    'opacity-70': loading || unauthorized
  }"
  (click)="onCardClick()"
  (keydown.enter)="onCardClick()"
  [attr.tabindex]="isDisabled ? -1 : 0"
  role="button"
  [attr.aria-disabled]="isDisabled"
>
  <div class="flex items-center gap-3">
    <span
      class="inline-flex h-10 w-10 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white shadow-sm dark:bg-surface-3"
    >
      <img [src]="product.logoUrl" [alt]="product.label" class="h-7 w-7 object-contain" />
    </span>
    <div class="min-w-0">
      <h3 class="text-[18px] font-bold leading-tight text-[#141437] dark:text-white">{{ product.label }}</h3>
      @if (unauthorized && !loading) {
        <p class="mt-0.5 text-[12px] font-medium text-[#b45309] dark:text-amber-300">No access</p>
      }
    </div>
  </div>

  <div
    class="mt-5 flex items-start justify-between gap-4 pb-6"
    [class.min-h-[76px]]="!showAmountToPay"
    [class.justify-end]="!showAmountToPay && !loading && hasUrgent"
  >
    @if (showAmountToPay) {
      <div class="min-w-0">
        <p class="text-[13px] font-medium text-[#7d7d93] dark:text-ink-muted">Amount To Pay</p>
        @if (loading) {
          <div class="mt-2 h-9 w-36 animate-pulse rounded-md bg-[#dde3ea] dark:bg-surface-3"></div>
        } @else {
          <p class="mt-1 text-[28px] font-bold leading-none tracking-[-0.02em] text-[#141437] dark:text-white">
            {{ (data?.totalPaymentToPay ?? 0) | currency }}
          </p>
        }
      </div>
    }

    @if (!loading && hasUrgent) {
      <div class="shrink-0 text-right">
        <p class="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#9333ea] dark:text-[#d8b4fe]">
          <span class="h-2 w-2 rounded-full bg-[#9333ea]"></span>
          {{ data?.urgentPaymentsCount ?? 0 }} Urgent Payments
        </p>
        <p class="mt-1 text-[18px] font-bold leading-none text-[#9333ea] dark:text-[#d8b4fe]">
          {{ (data?.urgentPaymentsAmount ?? 0) | currency }}
        </p>
      </div>
    }
  </div>

  <div
    class="mt-auto pt-5"
    [ngClass]="{
      'border-t border-[#dde3ea] dark:border-surface-3': showAmountToPay
    }"
  >
    @if (loading) {
      <div class="flex items-start justify-between gap-4">
        <div class="h-10 w-28 animate-pulse rounded-md bg-[#dde3ea] dark:bg-surface-3"></div>
        <div class="h-10 w-28 animate-pulse rounded-md bg-[#dde3ea] dark:bg-surface-3"></div>
      </div>
    } @else {
      <div class="flex items-start justify-between gap-4">
        <div class="min-w-0">
          <p class="text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Stripe Balance</p>
          <p class="mt-1 text-[16px] font-bold text-[#141437] dark:text-white">
            {{ (data?.availableBalance ?? 0) | currency : 'USD' : 'symbol' : '1.0-0' }}
          </p>
        </div>
        <div class="shrink-0 text-right">
          <p class="text-[12px] font-medium text-[#7d7d93] dark:text-ink-muted">Upcoming Amount</p>
          <div class="mt-1 flex flex-wrap items-center justify-end gap-x-2 gap-y-1">
            <span class="text-[16px] font-bold text-[#141437] dark:text-white">
              {{ (data?.upcomingAmount ?? 0) | currency : 'USD' : 'symbol' : '1.0-0' }}
            </span>
            @if (hasUpcoming) {
              <span class="inline-flex items-center gap-1 text-[12px] font-medium text-[#15b268] dark:text-[#7ae5ac]">
                <span class="h-1.5 w-1.5 rounded-full bg-[#15b268]"></span>
                In 2 Days
              </span>
            }
          </div>
        </div>
      </div>
    }
  </div>
</article>
